const MarketLogo = ({ width = 36, height = 36 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5424_9453)">
        <path d="M17.6471 11.7692H12V6.23077L17.6471 11.7692Z" fill="white" />
        <path d="M30.353 36H36.0001V30.4615L30.353 36Z" fill="white" />
        <path d="M12 12.4615H23.2941V23.5385L12 12.4615Z" fill="white" />
        <path
          d="M5.64697 24.2308H11.294V29.7692L5.64697 24.2308Z"
          fill="white"
        />
        <path d="M5.64697 0H11.294V5.53846L5.64697 0Z" fill="white" />
        <path
          d="M20.4705 11.7692C22.0299 11.7692 23.294 10.5294 23.294 9C23.294 7.4706 22.0299 6.23077 20.4705 6.23077C18.9111 6.23077 17.647 7.4706 17.647 9C17.647 10.5294 18.9111 11.7692 20.4705 11.7692Z"
          fill="white"
        />
        <path
          d="M33.1766 24.2308C34.7359 24.2308 36.0001 22.9909 36.0001 21.4615C36.0001 19.9321 34.7359 18.6923 33.1766 18.6923C31.6172 18.6923 30.353 19.9321 30.353 21.4615C30.353 22.9909 31.6172 24.2308 33.1766 24.2308Z"
          fill="white"
        />
        <path
          d="M5.64706 23.5385C8.76584 23.5385 11.2941 21.0588 11.2941 18C11.2941 14.9412 8.76584 12.4615 5.64706 12.4615C2.52827 12.4615 0 14.9412 0 18C0 21.0588 2.52827 23.5385 5.64706 23.5385Z"
          fill="white"
        />
        <path
          d="M11.2941 35.3077C11.2941 32.3699 10.1042 29.5525 7.98615 27.4751C5.86809 25.3978 2.99539 24.2308 0 24.2308L0 35.3077H11.2941Z"
          fill="white"
        />
        <path
          d="M17.647 5.53846C17.6493 4.07027 18.245 2.66287 19.3035 1.62471C20.3621 0.586538 21.7971 0.00228868 23.294 0V5.53846H17.647Z"
          fill="white"
        />
        <path
          d="M29.6471 12.4615C29.6447 13.9297 29.049 15.3371 27.9905 16.3753C26.932 17.4135 25.497 17.9977 24 18V12.4615H29.6471Z"
          fill="white"
        />
        <path
          d="M5.64697 11.7692C5.64931 10.301 6.24501 8.89365 7.30354 7.85548C8.36206 6.81731 9.79706 6.23306 11.294 6.23077V11.7692H5.64697Z"
          fill="white"
        />
        <path
          d="M36 11.7692C36 8.64784 34.7357 5.65429 32.4853 3.44713C30.2348 1.23997 27.1826 0 24 0V11.7692H36Z"
          fill="white"
        />
        <path d="M4.94118 0H0V11.7692H4.94118V0Z" fill="white" />
        <path d="M36.0001 12.4615H30.353V18H36.0001V12.4615Z" fill="white" />
        <path
          d="M29.518 21.3432L26.8164 18.6936L24.1148 21.3432L26.8164 23.9929L29.518 21.3432Z"
          fill="white"
        />
        <path d="M29.6471 24.9231H24V36H29.6471V24.9231Z" fill="white" />
        <path
          d="M36.0001 24.9231H30.353V30.4615H36.0001V24.9231Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_5424_9453">
          <rect width="36" height="36" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { MarketLogo };
